/* documentTitleMapping.js */

'use strict';
module.exports = {
    "default":"Gluware",
    "PasswordReset":"Gluware Password Reset"
};
